import { Injectable } from '@angular/core'
import { Store, StoreConfig } from '@datorama/akita'
import { Profile, Settings } from './user.model'

export interface UserState {
  profile: Profile | null
  settings: Settings | null
}

export function createInitialState(): UserState {
  return {
    profile: null,
    settings: null,
  }
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'user' })
export class UserStore extends Store<UserState> {
  constructor() {
    super(createInitialState())
  }
}
